import React, { useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import HomeScreen from '../components/26ua-prl-sign/home-screen';
import ReviewFlowScreen from '../common/review-flow-screen';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import { ScreensContext } from '../contexts/screensContext';
import useScreenHistory from '../hooks/useScreenHistory';

const UaPrlSign = ({ handleToBrandLinePage = null }) => {
  const { screenNumber, setScreenNumber, historyState, updateHistoryState } =
    useScreenHistory({
      initialScreen: 1,
      initialState: {}
    });
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const [endSessionType, setEndSessionType] = useState('SESSION_END');

  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    init('26UA-PRL-Sign');
    sendEvent('age_verification_without');
    sessionStorage.setItem('unsubscription_source', 'prl_signature');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case 1: {
        return (
          <HomeScreen
            handleToReview={() => cb(2)}
            handleToBrandLinePage={handleToBrandLinePage}
          />
        );
      }
      case 2: {
        return (
          <ReviewFlowScreen
            setScreenNumber={cb}
            innerScreenNumber={historyState.innerScreenNumber}
            setInnerScreenNumber={(val) =>
              setScreenNumber(2, false, { innerScreenNumber: val })
            }
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };

  return (
    <ScreensContext.Provider
      value={{
        endSessionType,
        setEndSessionType,
        isDisplayedAll,
        setIsDisplayedAll
      }}
    >
      {getScreen(screenNumber, setScreenNumber)}
    </ScreensContext.Provider>
  );
};

export default UaPrlSign;
